import { Component, Input, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StandardResponseModel } from 'src/api-providers/models/event.model';
import { EventsViewModel } from 'src/api-providers/view-models/events.view.model';

@Component({
  selector: 'app-participants-email-send',
  templateUrl: './participants-email-send.component.html',
  styleUrls: ['./participants-email-send.component.scss']
})
export class ParticipantsEmailSendComponent {
  @Input('slug') slug:any
  @ViewChild('btnclose') btnclose:any
  emailSenderResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel())
  sender_account:any 
  subject:any
  mailBody:any
  email_type:any
  constructor( private eventsVM: EventsViewModel,){
    this.eventsVM.participantsEmailSendComponent = this
    // this.eventsVM.getEventSenderList();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.eventsVM.subscribeToEmailSenderResponseModel(this.emailSenderResponseModel);
    this.eventsVM.getEventSenderList();
  }

  sendAdmitCard(){
    let data = {sender_account:this.sender_account, slug:this.slug}
    this.eventsVM.sendAdmitCard(data)
  }

  cardSend(){
    // this.btnclose.nativeElement.click()
    document.getElementById('btnclose')?.click()
  }
}
